export default __webpack_public_path__ + "static/media/(10).b87cf6aa.jpg";